import React, { useState } from 'react';
import { Grid, Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import routeNames from '../../../../routes/routeNames';
import { CustomButton, OncologyBox } from '../../../shared';
import { ONCOLOGY_DATA } from './constants';
import { setHeaderTitle } from '../../../../redux/reducers/headerReducer';
import OncologySkeleton from './skeleton';
import { updateStringNPPA } from '../../../../utility';
import { prodQaCompnies, REZLIDHIA_COMPANY_ID } from '../../../../constants';

const Triggers = (props) => {
    const {} = props;
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { triggers, isTriggerLoading } = useSelector(
        (state) => state.trigger,
    );
    const { company } = useSelector((state) => state.company);
    const {
        userDetails: { is_admin = false },
    } = useSelector((state) => state.user);

    const [hovered, setHovered] = useState(-1);
    const showTriggerSummary = [33, 66, 62, 161].includes(company.id);
    const MouseEnter = (index) => {
        setHovered(index);
    };
    const MouseLeave = () => {
        setHovered(-1);
    };

    const triggerClick = (triggerName) => {
        const updatedTriggerName = updateStringNPPA(triggerName);
        dispatch(setHeaderTitle(updatedTriggerName));
        navigate(
            `${routeNames.TRIGGER.replace(':trigger', encodeURIComponent(triggerName))}`,
        );
    };

    const handleTriggersSummary = () => {
        navigate(routeNames.TRIGGERS_SUMMARY);
    };

    const renderNoTriggerData = () => (
        <Grid container>
            <Grid item xs={12}>
                <Box className="flex-row-center oncology-box">
                    <Typography className="text-sm-regular gray-900">
                        No trigger engagement data to display
                    </Typography>
                </Box>
            </Grid>
        </Grid>
    );

    const renderTriggerData = () =>
        triggers?.length ? (
            <>
                {showTriggerSummary || is_admin ? (
                    <Grid>
                        <Box className="ml-2 mb-2">
                            <Box>
                                <CustomButton
                                    buttonColor="#AD509E"
                                    handleClick={handleTriggersSummary}
                                    title="Triggers Summary"
                                    titleColor="#FFFFFF"
                                />
                            </Box>
                        </Box>
                    </Grid>
                ) : null}

                <Grid container data-testid="trigger_boxes" spacing={3}>
                    {triggers?.map((data, index) => {
                        const current = data?.volume || 0;
                        const previous = data?.previousVolume || 0;
                        const change =
                            previous === 0 && current === 0
                                ? 0
                                : ((current - previous) * 100) / previous;
                        return (
                            <Grid
                                item
                                key={'trigger' + index}
                                xs={4}
                                onMouseEnter={() => MouseEnter(index)}
                                onMouseLeave={MouseLeave}
                            >
                                <OncologyBox
                                    boxData={data}
                                    change={change}
                                    current={current}
                                    handleClick={() => triggerClick(data.name)}
                                    isRating={true}
                                    oncologyId={index}
                                    previous={previous}
                                    selectedOncologyId={hovered}
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            </>
        ) : (
            renderNoTriggerData()
        );

    return isTriggerLoading ? (
        <Grid container spacing={3}>
            {Array.from({ length: 3 })?.map((_, index) => (
                <Grid item key={'trigger-skeleton' + index} xs={4}>
                    <OncologySkeleton />
                </Grid>
            ))}
        </Grid>
    ) : (
        renderTriggerData()
    );
};

export default Triggers;
